<template>
    <div>
        <contact-info
            ref="refContactInfo"
            :user-profile-id="userProfileId"
            :user-profiles-data="userProfilesData"
        />
        <div class="align-center-bottom btn-save-contact-info-container">
            <ejs-button
                type="button"
                cssClass="e-info margin-button"
                v-on:click.native="onSubmitContactClick(false)"
                >Save Contact Information</ejs-button
            >
        </div>
    </div>
    </template>

<script>
import Vue from "vue";

import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import ContactInfo from "./contact-info.vue";

Vue.use(ButtonPlugin);

export default {
  name: "ManageCustomer",
  components: {
    ContactInfo,
  },
  props: {
    userProfileId: String,
    userProfilesData: Object,
  },
  data() {
    return {

    };
  },
  methods: {
    onSubmitContactClick(hideNofificationMessage = false) {
      let isValid = true;
      const contactInfo = this.$refs.refContactInfo;
      isValid = contactInfo.validateContact();
      if (isValid) {
        contactInfo.updateUserContacts(hideNofificationMessage);
      } else {
        contactInfo.notify('Error', 'Opss! Something went wrong.');
      }
      return isValid;
    },
  },
};
</script>
